<template lang="pug">
client-only
  .fb-share-button(:data-href="snsUrl" data-layout="button_count" data-size="small" data-mobile-iframe="true")
    a.fb-xfbml-parse-ignore(target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&amp;src=sdkpreparse`")
      | シェア
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    currentPath: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      snsUrl: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line
      (function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; js = d.createElement(s); js.id = id; js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v6.0&appId=1736888553253336"; fjs.parentNode.insertBefore(js, fjs); }(document, 'script', 'facebook-jssdk'));
      this.setUrl()
      const timer = setInterval(() => {
        if (window.FB && window.FB.XFBML) {
          window.FB.XFBML.parse()
          clearInterval(timer)
        }
      }, 100)
    })
  },
  methods: {
    setUrl() {
      if (this.currentPath) {
        this.snsUrl = location.origin + this.currentPath
        return
      }
      this.snsUrl = this.url
    }
  }
}
</script>
